"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildNotesSection = void 0;
const DefaultSubsections = require("./helpers/defaultSubsections");
function buildNotesSection(section) {
    return {
        type: 'notes',
        description: section.description || 'Patient Notes Section',
        subsections: [
            DefaultSubsections.patientID(),
            {
                subtitle: 'Note Title',
                displayType: 'text',
                dataAccessor: ['data', 'title'],
            },
            {
                subtitle: 'Note Body',
                displayType: 'text',
                dataAccessor: ['data', 'body'],
            },
            {
                subtitle: 'Note Files',
                displayType: 'files',
                dataAccessor: ['data', 'files'],
            },
            {
                subtitle: 'Edited By',
                displayType: 'text',
                dataAccessor: ['data', 'title'],
            },
            {
                subtitle: 'Created By',
                displayType: 'user',
                dataAccessor: ['creator'],
            },
            DefaultSubsections.created_at(),
            DefaultSubsections.updated_at(),
        ],
    };
}
exports.buildNotesSection = buildNotesSection;
//# sourceMappingURL=patientNotesSection.js.map